// test701
(701 && 0);
